// extracted by mini-css-extract-plugin
module.exports = {"filter":"SimpleWaterBodyFilter_filter__1-F21","filterBtn":"SimpleWaterBodyFilter_filter-btn__1EfDo","icon":"SimpleWaterBodyFilter_icon__T52k_"};